import { type IKnownBusinessEntitySaleItem } from "@/interfaces/api/known-business-entity-sale-item.interface.ts"
import { BaseModel } from "@/models/base.model"

export class KnownBusinessEntitySaleItem extends BaseModel implements IKnownBusinessEntitySaleItem {
  public static className = "KnownBusinessEntitySaleItem" // Used for socket communication.
  public static verboseName = "bedrijfsverkoopafspraak"

  saleItem: string
  knownBusinessEntity: string

  unitPrice?: string
  surchargeModifier?: string

  constructor(knownBusinessEntitySaleItem: IKnownBusinessEntitySaleItem) {
    super(knownBusinessEntitySaleItem)

    this.saleItem = knownBusinessEntitySaleItem.saleItem
    this.knownBusinessEntity = knownBusinessEntitySaleItem.knownBusinessEntity

    this.unitPrice = knownBusinessEntitySaleItem.unitPrice
    this.surchargeModifier = knownBusinessEntitySaleItem.surchargeModifier
  }
}
